var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom-button",class:{on: _vm.toggled}},[_c('a',{on:{"click":_vm.clicked}},[_c('img',{attrs:{"src":_vm.img,"alt":_vm.img_alt}})]),_c('div',{staticClass:"hint"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }